module.exports = function InvalidMonthsError(message) {
  this.message = message;
  this.name = 'InvalidMonthsError';
};
